export default __webpack_public_path__ + "static/takeaway-points-429a8856f9979804e90c1a69c5173e30.png";